export default class TargetTask {
	id ?: string; // 后端存储的时候生成
	content : string; // 内容
	status ?: number; // 状态，数字和后端约定好，请求和后端存储的时候均使用数字类型
	targetId ?: string;// 所属目标
	dueDate : string | null; // 期望完成日期，可以为空（如果是重复任务）
	finishTime : Date | null; // 完成时间
	remark : string | null; // 任务完成描述

	constructor() {
		this.id = "";
		this.content = "";
		this.remark = "";
		this.dueDate = null;
		this.finishTime = null;
	}
}